import type { RefObject } from 'react'
import { observer } from 'mobx-react-lite'
import { type ConversationViewModel } from '@/features/messaging/ConversationViewModel'
import { Messages } from '@/features/messaging/components/ConversationView/Messages'
import { type WelcomeAction } from './Welcome'
import { WelcomeContainer } from '@/features/messaging/components/ConversationView/Messages/Welcome/WelcomeContainer'
import { ListContainer } from '@/features/messaging/components/ConversationView/Messages/List/ListContainer'

export interface MessagesContainerProps {
  vm: ConversationViewModel
  small?: boolean
  welcomeActions?: WelcomeAction[]
  scrollRef?: RefObject<HTMLDivElement | null>
}

export const MessagesContainer = observer(function MessagesContainer({
  vm,
  small,
  welcomeActions,
  scrollRef,
}: MessagesContainerProps) {
  return (
    <Messages
      scrollRef={scrollRef}
      messageCount={vm.messages.length}
      onLoadMore={vm.fetchMore}
      welcome={
        <WelcomeContainer
          welcomeActions={welcomeActions}
          small={small}
          vm={vm}
        />
      }
      list={<ListContainer vm={vm} />}
    />
  )
})
